import { createStore } from 'vuex'

export default createStore({
  state: {
    user: JSON.parse(localStorage.getItem('user')) || null,
    token: localStorage.getItem('token') || null,
  },
  getters: {
    isLoggedIn: state => !!state.token,
    currentUser: state => state.user,
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user;
      localStorage.setItem('user', JSON.stringify(user));
    },
    SET_TOKEN(state, token) {
      state.token = token;
      localStorage.setItem('token', token);
    },
    CLEAR_AUTH(state) {
      state.user = null;
      state.token = null;
      localStorage.removeItem('user');
      localStorage.removeItem('token');
    }
  },
  actions: {
    login({ commit }, { user, token }) {
      commit('SET_USER', user);
      commit('SET_TOKEN', token);
    },
    updateUser({ commit }, user) {
      commit('SET_USER', user);
    },
    logout({ commit }) {
      commit('CLEAR_AUTH');
    }
  },
  modules: {
  }
})

// Cross-tab authentication synchronization
window.addEventListener('storage', (event) => {
  if (event.key === 'token') {
    const newToken = event.newValue;
    if (!newToken) {
      // Token removed in another tab (Logout)
      window.location.reload(); // Force reload to clear state and redirect
    } else {
      // Token added/updated in another tab (Login/Refresh)
      window.location.reload();
    }
  }
});
